<template>
  <div class="row">
    <div v-for="r in resources.data" :key="'st' + r.id" class="col col-md-6 col-xl-4 mb-4">
      <booking-card :r="r" :collection="'myScheduleToday'" @refresh="index(1)" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'MyScheduleToday',
  mounted () {
    this.index(1)
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      resources: state => state.myScheduleToday,
      submitting: state => state.submitting
    })
  },
  methods: {
    index (page, count) {
      if (page) this.$store.commit('pushState', { view: this.$options.name, key: 'page', data: page })
      if (count) this.$store.commit('pushState', { view: this.$options.name, key: 'tableRows', data: count })
      this.$store.dispatch('index', {
        collection: this.$options.name,
        data: {
          icon: ['fal', 'address-book']
        }
      })
    }
  }
}
</script>
